// store.ts
import React from "react";
import { create } from "zustand";

export type MusicType = {
  id: string;
  title: string;
  artist: string;
  url: string;
  cover: string;
};

interface MusicActions {
  addMusic: (music: MusicType) => void;
  setSongIndex: (songIndex: number) => void;
  setIsPlaying: (isPlaying: boolean) => void;
  removeMusic: (id: string) => void;
  setIsMuted: (isMuted: boolean) => void;
  setIsSongFetching: (fetchingSong: boolean) => void;
  setProgress: (progress: number) => void;
  setDuration: (duration: number) => void;
  setPlayerRef: (
    playerRef: React.MutableRefObject<HTMLAudioElement | null>
  ) => void;
}

interface MusicStore {
  playerRef: React.MutableRefObject<HTMLAudioElement | null> | null;
  isPlaying: boolean;
  songIndex: number;
  isMuted: boolean;
  isSongFetching: boolean
  duration: number
  musicHistory: MusicType[];
  progress: number
  actions: MusicActions;
}

const useMusicStore = create<MusicStore>((set) => ({
  musicHistory: [],
  isPlaying: false,
  songIndex: 0,
  progress: 0,
  duration: 0,
  isMuted: false,
  isSongFetching: false,
  playerRef: null,
  actions: {
    setDuration: (duration) => set({ duration }),
    setProgress: (progress) => set({ progress }),
    setPlayerRef: (playerRef) => set({ playerRef }),
    setSongIndex: (songIndex) => set({ songIndex }),
    setIsPlaying: (isPlaying) => set({ isPlaying }),
    setIsSongFetching: (isSongFetching) => set({ isSongFetching }),
    setIsMuted: (isMuted) => set({ isMuted }),
    addMusic: (newMusic) =>
      set((state) => ({
        musicHistory: [...state.musicHistory, newMusic],
      })),
    removeMusic: (id) =>
      set((state) => ({
        musicHistory: state.musicHistory.filter((music) => music.id !== id),
      })),
  },
}));

export const useMusicActions = () => useMusicStore((state) => state.actions);
export default useMusicStore;
